module.exports = __webpack_public_path__ + "img/2.a1e3e3cc.jpg";